'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './content-slider-editor.routes';

export class ContentSliderEditorComponent {

  constructor($uibModal, SettingsService, dialogs) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.SettingsService = SettingsService;

    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["h4","h5"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["undo","redo"],
      ["insertLink"],
      ["backgroundColor","fontColor","fontName", "fontSize"]
    ];

    this.sortableOptions = {
      handle: '.handle'
    };

    SettingsService.getByName({name: 'content-slider-main'}, setting => {
      this.setting = setting;
      this.slider = setting.data;
    })
  }

  removeSlide($event, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Slide?", "Do you really want to delete the "+(idx+1) + ". slide?");
    dlg.result.then(() => {
      this.slider.slides.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  addSlide() {
    this.slider.slides.push({
      title: "",
      html: ""
    });
  }

  removeAsset(idx) {
    delete this.slider.slides[idx].image;
  }

  openAssetBrowserModal(idx) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToFileTypes: ["image/jpeg", "image/png"],
            restrictToPublicFiles: true
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {

        if(newlySelectedAssets.length) {
          that.slider.slides[idx].image = "/api/storage/public/" + newlySelectedAssets[0]._id;
        }

      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal(idx) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'image/*',
            forcePublic: true
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        if (result.length) {
          that.slider.slides[idx].image = "/api/storage/public/" + result[0];
        }

      },
      function () { /* cancel */ }
    );

  }

  /*
  openSliderUpload() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      size: 'lg',
      component: 'sliderUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (storageId) {
        that.slider.slides.push({
          active: '',
          image: "/api/storage/public/"+ storageId
        });
      },
      function () {  }
    );

  }

   */

  save() {
    this.setting.data = this.slider;
    this.SettingsService.update({id: this.setting._id}, this.setting, _ => {
      this.dialogs.notify("Success","The content slider has been updated successfully");
    }, err => {
      console.log('There has been an error.')
    });
  }
}

export default angular.module('conduu.contentSliderEditor', [uiRouter])
  .config(routes)
  .component('contentSliderEditor', {
    template: require('./content-slider-editor.html'),
    controller: ContentSliderEditorComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/content-slider/content-slider-editor.component.js